import React from "react";
import PropTypes from "prop-types";
import axios from "axios/index";

import Modal from "../Modal";
import ListCustomForms from "./ListCustomForms";
import Pagination from "../general/Pagination";
import Loading from "../general/Loading.js";

const PER_PAGE = 10;

class AddForm extends React.Component {
  state = {
    loading: false,
    visible: false,
    forms: [],
    page: 1,
    totalPages: 0
  };

  componentDidMount() {
    if(this.props.visible)
      this.handlerToggle();
  }

  render() {
    const { loading, visible, totalPages, page, forms } = this.state;

    return (
      <div className="pull-left">
        <button 
          tabIndex={0}
          className="btn btn-pink btn-raised btn-long"
          onClick={this.handlerToggle}
        >
          ADD
        </button>

        <Modal title="Add Form" visible={visible} onClose={this.handlerToggle}>
          <div>
            {forms.length === 0 ? null : (
              <div>
                <ListCustomForms forms={forms} />
                {totalPages > 1 ? (
                  <Pagination
                    page={page}
                    totalPages={totalPages}
                    changePage={this.handlerChangePage}
                  />
                ) : null}
              </div>
            )}

            <Loading
              loading={loading}
              noDataMessage={forms.length === 0 ? "No Forms Found" : null}
            />
          </div>
        </Modal>
      </div>
    );
  }

  handlerToggle = () => {
    this.setState({ visible: !this.state.visible }, () => {
      if (this.state.visible) {
        this.loading();
      }
    });
  };

  handlerChangePage = n => {
    this.setState({ page: this.state.page + n }, () => {
      this.loading();
    });
  };

  loading = () => {
    let { location } = this.props;
    if (!location) {
      location = window.Application.currentLocations
        .map(l => l.id)
        .join(",");
    }

    const url = `/custom_forms.json?per_page=${PER_PAGE}&page=${
      this.state.page
    }&location_id=${location}`;

    this.setState({ loading: true });
    axios.get(url).then(resp => {
      this.setState({
        forms: resp.data.custom_forms,
        totalPages: Math.ceil(parseInt(resp.headers.total) / PER_PAGE),
        loading: false
      });
    });
  };
}

AddForm.propTypes = {
  location: PropTypes.string,
  visible: PropTypes.bool
};

export default AddForm;
